import React, { createContext, useContext, useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export const getLocalHistoryRoute = (history: string[], condition: string): string => {
    return history.filter((item) => !item.startsWith(condition)).pop() || "/";
};

type LocalHistoryContextType = string[];

const LocalHistoryContext = createContext<LocalHistoryContextType>([]);

export const LocalHistoryProvider = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();
    const historyRef = useRef<string[]>([]);
    const navigationType = useNavigationType();

    useEffect(() => {
        const currentPath = location.pathname + location.search;
        const lastPath = historyRef.current[historyRef.current.length - 1];

        if (navigationType === "REPLACE") {
            historyRef.current[historyRef.current.length - 1] = currentPath;
        } else if (navigationType === "PUSH") {
            if (lastPath !== currentPath) {
                historyRef.current.push(currentPath);
            }
        } else if (navigationType === "POP") {
            if (lastPath !== currentPath) {
                historyRef.current.push(currentPath);
            }
        }
    }, [location, navigationType]);

    const value = historyRef.current;

    return (
        <LocalHistoryContext.Provider value={value}>
            {children}
        </LocalHistoryContext.Provider>
    );
};

export const useLocalHistory = (): LocalHistoryContextType => {
    const localHistory = useContext(LocalHistoryContext);

    return localHistory;
};
